/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { Injectable } from '@angular/core';
import {
  HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpClient,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { LoggedOutService } from './logged-out.service';

/**
 * Interceptor to check the logged in header on all requests.
 */
@Injectable()
export class LoggedInHeaderInterceptor implements HttpInterceptor {

  constructor(private loggedOutService: LoggedOutService, private http: HttpClient) { }

  /**
   * Intercepts request responses and updates the Logged Out service appropriately.
   * @param request to get the response from.
   * @param next to continue the chain.
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      filter((event) => event instanceof HttpResponse),
      tap((event: HttpResponse<any>) => {
        if (event.status === 403 && !event.headers.get('X-BULB-LOGGED-IN')) {
          // Some 403's don't return a header if the request was not a GET.
          // This is a hacky fix to that by doing an extra GET request, which always will have the logged in header.
          this.http.get('/config');
        } else if (!event.status.toString().startsWith('5')) {
          this.loggedOutService.wasPreviouslyLoggedIn = this.loggedOutService.isLoggedIn;
          this.loggedOutService.isLoggedIn = event.headers.get('X-BULB-LOGGED-IN') === 'true';
        }
        return event;
      }),
    );
  }
}
